import { themeGet } from '@magalu/stereo-ui-styles';
import styled from 'styled-components';
export const LoyaltyContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: ${props => props.color || '#fff'};
  border-radius: 6px;
  padding: 3px 5px;
  cursor: default;
`;
export const TransparentButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  line-height: 0px;
`;
export const LoyaltyText = styled.p`
  font-size: ${props => themeGet('fontSizes.0')(props)}px;
  font-weight: ${props => themeGet('fontWeights.bold')(props)};
  color: ${props => props.color || '#fff'};
  margin: 0 5px;
`;